<template>
  <div>
    <div class="h-dialogContainer" >
      <template>
        <ParseForm ref="basic" :formId="formItems.basic.formId" :formParams="formItems.basic.formObj" :opCode="opCode" :funcClick="bindClickInterface"></ParseForm>
      </template>    
      <DnnProfileList ref='dnnProfileList' :getCheckedDatas='getCheckedList' ></DnnProfileList>
    </div>
  </div>
</template>
<script>
import ParseForm from '../../../util/parseFormNew/ParseForm';
import DnnProfileList from "./DnnProfileList";
import CustomDialog from '../../../../common/CustomDialog';
import SubscriberTool from '../../../util/parseFormNew/tools/subscriberTool';
import ajaxUrl from "../../../data/ajaxUrl";

export default {
  name: "AddProfileForm",
  components: {
    ParseForm,
    DnnProfileList,
    CustomDialog,
  }, 
  methods: {
    getDatas() {
      const map = new Map();
      if (this.$refs.basic) {
        if (!this.$refs.basic.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.basic.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }    
      console.log(map);
      return map;
    },
    getJson(ne, callback) {  
      this.ne = ne;
      const params = {
        msgid: this.msgId,
        neid: ne.neid,
      };
      this.$axios.post(ajaxUrl.snssaiJson, params).then(response => {
        if (!response) {
          console.log("getJson response error");
          return;
        }
        if (!response.data) {
          console.log("getJson response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("getJson response.data.resultVal error");
          return;
        }
        if (response.data.errorCode !== "0") {
          console.log("getJson response.data.errorCode error");
          callback(response);
          return;
        }
        const res = response.data.resultVal;  
        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(res, []);
          console.log("resultMaplcc",resultMap);

        this.formItems.basic.formObj = resultMap.get(this.formItems.basic.modelName);
        callback(response);
      });      
    },
    saveProfile(ne, callback) {
      const formData = this.getDatas();      
      if (formData) {    
        const pdnList = formData.get("dnnProfileList").split(',').filter((item) => { return parseInt(item) !== "" });        
       const pdnList2 = [];
        pdnList.forEach(element => {
          pdnList2.push(parseInt(element));
        });
        const params = { 
          vo: {
            "neid": ne.neid,
            "profileId": parseInt(formData.get("profileId")),
            "profileName": formData.get("profileName"),
            "sst": parseInt(formData.get("sst")),
            "sd": formData.get("sd"),
            "dnnProfileList":pdnList2
          }, 
          info: {
            msgid: this.msgId,
            neid: ne.neid,
          }
        };
        console.log("params",params);
        this.$axios.post(ajaxUrl.requestCommonD, params).then((response) => {
          if (callback) {
            callback(response);
          }
        });
      } 
    }, 
    showProfileList() {
      this.$refs.dnnProfileList.qryList(this.ne);
      this.$refs.dnnProfileList.show();
    }, 
    getCheckedList(list) {   
      this.selectedKeys = [...list];      
      let value = '';   
      let range = '';
      for(let i=0; i<list.length; i++) {
        value += list[i];
        range += list[i];
        if(i != list.length-1) {
          value += ',';
          range += '|';
        }
      }
      if(this.$refs.basic) {
        this.$refs.basic.setData('dnnProfileList', value);
      } 
    },
    onclickDnnProfileLst() {
      this.$refs.dnnProfileList.qryList(this.ne);
      this.$refs.dnnProfileList.show();
    },
  },
  computed: {
    bindClickInterface() { 
      this.funcMap = new Map();      
      this.funcMap.set('dnnProfileList', () => { this.onclickDnnProfileLst(); });      
      return this.funcMap;
    }
  },
  data() {
    return {      
      ne: null,
      selectedKeys: [],
      funcMap: null,
      formItems: {
        basic: {
          formId: "SnssaiAddProfileInfo",
          modelName: "basic",
          formObj: null,
        },
      }, 
      opCode: "add",
      msgId: "28676",
    };
  },  
  beforeDestroy() {
  }
};
</script>
